import { useState } from 'react'
import { Box, Button, Grid, Stack } from '../../../imports/muiImport'
import GreetCover from './GreetCover'
import AddPhotoSection from './AddPhotoSection';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';

const CardDesignForm = () => {
    const [addPhoto, setAddPhoto] = useState(false);
    const [addcustomMsg, setcustomMsg] = useState(false);

    const handleSection = (key) => {
        if (key === 'ADDPHOTO') {
            if (addcustomMsg) {
                setcustomMsg(false);
            }
            setAddPhoto((prevState) => !prevState);
        }

        if (key === 'ADDCUSTOMMESSAGE') {
            if (addPhoto) {
                setAddPhoto(false);
            }
            setcustomMsg((prevState) => !prevState);
        }
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <GreetCover />
            
            <Stack justifyContent={"center"} alignItems={"center"}> 
                <Button
                    variant='contained'
                    fullWidth
                    startIcon={<AddAPhotoIcon />}
                    sx={{
                        py: 1.5,
                        maxWidth: 230,
                        color: 'dark.main',
                        backgroundColor: 'background.main3',
                        borderRadius: 1,
                        boxShadow: 0,
                        textTransform: 'capitalize',
                        fontSize: '1.325rem',
                        fontWeight: 400,

                        "&:hover": {
                            backgroundColor: 'background.main3',
                            boxShadow: 3,
                        }
                    }}
                    onClick={() => handleSection('ADDPHOTO')}
                >
                    Add Photo
                </Button>
            </Stack>

          

            {addPhoto &&
                <Grid item xs={12} sx={{ py: 2, }}>
                    <AddPhotoSection handleSection={handleSection} />
                </Grid>
            }

            {/* <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', height: 35, px: 3, }}>
                    <Button
                        variant='contained'
                        fullWidth
                        sx={{
                            backgroundColor: 'background.main3',
                            color: 'primary.main',
                            boxShadow: 0,
                            borderRadius: 2,
                            "&:hover": {
                                backgroundColor: 'background.main3',
                                boxShadow: 5,
                            }
                        }}
                        onClick={() => handleSection('ADDCUSTOMMESSAGE')}
                    >
                        Custom Message
                    </Button>
                </Grid> */}



            {/* {addcustomMsg &&
                    <Grid item xs={12}>
                        Add Custom Message
                    </Grid>
                } */}
        </Box>
    )
}

export default CardDesignForm